<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="realized-gain-loss-form">
                    <icon name="file-invoice"></icon>
                    กำไร-ขาดทุน
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "realized-gain-loss-layout"
    }
</script>

<style scoped>

</style>